import React from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Filters from "./Filters";

export default function FilterDrawer({ open, onClose, ...filterProps }) {
  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: '90vw',
          maxWidth: 320,
          p: 0,
          // Fixed: Prevent scrolling issues
          height: '100vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        p: 2, 
        borderBottom: 1, 
        borderColor: 'divider',
        flexShrink: 0
      }}>
        <Typography variant="h6">Filters</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ 
        p: 2, 
        flex: 1,
        overflowY: 'auto' 
      }}>
        <Filters {...filterProps} isMobile />
      </Box>
    </Drawer>
  );
}